import Http from './base-http'

class RequestType extends Http {
  deleteRequestType(id) {
    return this.destroy(id)
  }
  addRequestType(data) {
    return this.client.post('/',data)
  }
  updateRequestType(id,data) {
    return this.client.put(`/${id}`,data)
  }
}

const request = new RequestType({
  modelUrlPrefix : 'requestType'
})

export default request

